import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Brand from '../../assets/IntugineLogo.png'
import { PersistentDrawer } from '@intuginetech/intureact'

// import { routesToResourceMapping } from '../../../helpers/routesToResourceMapping'

import LogoutIcon from '../common/Icons/Logout'

import { useTheme } from '@mui/material'

function SideNav({items,brandUrl}) {
  const theme = useTheme()

  const getLogo = (url) => {
    console.log("url",url)
    return url.replace("https://assetsstatic.s3.ap-south-1.amazonaws.com","https://staticassests.intusystems.info")
  }

  // const brandUrl = userConfig?.length
  //   ? userConfig?.find((item) => item?.name === 'common')?.interface_config?.brand_info?.logo_url
  //   : ''
  // const disabledModules = userConfig?.length
  //   ? userConfig?.find((item) => item?.name === 'common')?.interface_config?.disabled_modules
  //   : {}

 const logoutRoute={
  path: '/logout',
  moduleName: 'Logout',
  Icon: LogoutIcon,
  children: [],
  type: 'link',
 }

// console.log("items",items)
// console.log("brandUrl",brandUrl)

  let navigation = [...items,logoutRoute]
  // let bypassedPages = []

  // navigationItems.map((navItem) => {
  //   if (navItem?.children) {
  //     const subNavItems = navItem?.children?.filter((item) => {
  //       return (
  //         getPolicyMappedToRoute(item)?.action.includes('read') ||
  //         bypassedPages.filter((x) => item?.path.includes(x)).length > 0
  //       )
  //     })
  //     if (!(navItem?.path?.includes('freight') && disabledModules?.freight))
  //       subNavItems.length && navigation.push({ ...navItem, children: [...subNavItems] })
  //   } else {
  //     if (
  //       !(navItem?.path?.includes('freight') && disabledModules?.freight) &&
  //       getPolicyMappedToRoute(navItem)?.action.includes('read')
  //     )
  //       navigation.push({ ...navItem })
  //   }
  // })

  // let subnavMainRoutes = []
  // navigation.filter((x) => x?.children?.length && subnavMainRoutes.push('/' + x.path.split('/')[1]))

  return (
    <PersistentDrawer
      getPathName={useLocation}
      LinkElement={Link}
      toggleButtonProps={{
        sx: {
          height: '100%',
          backgroundColor: theme.palette.primary[50],
          color: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.primary[200],
          },
          borderRadius: 0,
          boxShadow: '-20px -20px 15px 10px rgba(0,0,0,0.75)',
          borderBottom: `1px solid ${theme.palette.primary[200]}`,
        },
        BurgerMenuProps: {
          sx: {
            color: theme.palette.primary.main,
          },
        },
      }}
      navigation={navigation}
      BrandLogo={
        <img
          src={getLogo(brandUrl || Brand)}
          style={{
            margin: 'auto 0px',
            width: 'auto',
            height: '50px',
          }}
        />
      }
    />
  )

  // return (
  //   <>
  //     <PersistentDrawer
  //       brandURL={brandUrl || Brand}
  //       callToActionButton={false}
  //       callToActionButtonProps={{ text: 'Add Trip', color: 'success', startIcon: <Add /> }}
  //       callToActionButtonCollapseProps={{ color: 'success', startIcon: <Add /> }}
  //       onToggleIconClick={handleToggle}
  //       expanded={expanded}
  //       footer={footer}
  //       getActiveItem={(navItem) =>
  //         location.pathname?.split('/')[1] === navItem.route?.split('/')[1]
  //       }
  //       LinkElement={NavLink}
  //       linkElementProps={{
  //         style: {
  //           textDecoration: 'none',
  //         },
  //       }}
  //       navigation={navigation}
  //       onNavItemClick={(navigation) => {
  //         navigation?.type === 'subNav' && setActiveSubNav(navigation)
  //       }}
  //       // navigation={finalNav}
  //       // onNavItemClick={(finalNav) => {
  //       //   finalNav?.type === 'subNav' && setActiveSubNav(finalNav)
  //       // }}
  //     />
  //     <SubNav
  //       zIndex={999}
  //       brandUrl={brandUrl || Brand}
  //       open={Boolean(activeSubNav)}
  //       onToggleIconClick={handleToggle}
  //       expanded={expanded}
  //       onClose={() => setActiveSubNav(null)}
  //       LinkElement={NavLink}
  //       footer={footer}
  //       linkElementProps={{
  //         style: {
  //           textDecoration: 'none',
  //         },
  //       }}
  //       navigation={activeSubNav}
  //     />
  //   </>
  // )
}

export default SideNav
